import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from 'components/system/Paper';
import Page from 'components/system/Page';
import useJobDetails from 'hooks/useJobDetails';
import JobMetadata from './JobMetadata';
import HybridJobOutputLoader from './ContentLoader/HybridJobOutputLoader';

const metadataStructure = [
  {
    label: 'Batch Id',
    key: 'batchId',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Device',
    key: 'device',
    tooltip: {
      quantum: 'This job was run on a quantum device',
      cpu: 'This job was simulated on a CPU',
      gpu: 'This job was simulated on a GPU',
    },
  },
  {
    label: 'Cost',
    key: 'cost',
  },
  {
    label: 'Created On',
    key: 'createdOn',
  },
  {
    label: 'Completed On',
    key: 'runEnd',
  },
  {
    label: 'Status',
    key: 'runStatus',
  },
  {
    label: 'Pending',
    key: 'pending',
  },
  {
    label: 'Completed',
    key: 'completed',
  },
  {
    label: 'Failed',
    key: 'failed',
  },
];

const HybridJob = ({ isLoading, isInProgress, ...details }) => {
  const {
    jobMetadataUrl,
    ...processedDetails
  } = useJobDetails({ ...details });

  return (
    <Container>
      <Page sx={{ flexGrow: 1, marginTop: '40px' }}>
        <Grid
          container
          direction="row"
          spacing={3}
          sx={{ height: '100%' }}
        >
          <Grid item xs={12}>
            <Paper sx={!isLoading ? { padding: '36px 24px 30px 24px !important' } : {}}>
              <JobMetadata
                isLoading={isLoading}
                metadataStructure={metadataStructure}
                metadata={processedDetails}
              />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              {isLoading && <HybridJobOutputLoader />}
              {!isLoading && (
                <div dangerouslySetInnerHTML={{ __html: details.notebookOutput }} />
              )}
            </Paper>
          </Grid>
        </Grid>
      </Page>
    </Container>
  );
};

export default HybridJob;
